import { render, staticRenderFns } from "./ProfileMunicipalityTransferDocuments.vue?vue&type=template&id=7484f0f8&scoped=true&"
import script from "./ProfileMunicipalityTransferDocuments.vue?vue&type=script&lang=js&"
export * from "./ProfileMunicipalityTransferDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMunicipalityTransferDocuments.vue?vue&type=style&index=0&id=7484f0f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7484f0f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7484f0f8')) {
      api.createRecord('7484f0f8', component.options)
    } else {
      api.reload('7484f0f8', component.options)
    }
    module.hot.accept("./ProfileMunicipalityTransferDocuments.vue?vue&type=template&id=7484f0f8&scoped=true&", function () {
      api.rerender('7484f0f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProfileMunicipalityTransferDocuments.vue"
export default component.exports